import React, { Component, useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import {
  Card,
  CardBody,
  CardHeader,
  CardSubtitle,
  CardText,
  CardTitle,
  Col,
  Collapse,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"

import classnames from "classnames"
import Applications from "./applications"
import Application from "services/applications/Application.service"
import Summary from "./Summary"

var appService = null

var plasticsUser = null

const tabs = props => {
  const [activeTab, setActiveTab] = useState("1")
  const [submitted, setsubmitted] = useState()
  const [mounted, setmounted] = useState(false)

  useEffect(() => {}, [activeTab])

  useEffect(() => {
    appService = new Application(props.user)
    //console.log(props.user)
    plasticsUser = appService.getStrategy("head")

    plasticsUser.getSubmittedApplications(1).then(response => {
      if (response.status) {
        // console.log(response.data)
        setsubmitted(response.data)
        setmounted(true)
      }
    })
  }, [])

  const toggle = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }

  const paginate = page => {
    plasticsUser.getSubmittedApplications(page).then(response => {
      if (response.status) {
        setsubmitted(response.data)
      }
    })
  }

  return (
    <Col>
      {/* <Summary
        data={{
          rejected: props.statistics.rejected,
          approved: props.statistics.approved,
          processing: props.statistics.processing,
          returned: [
            { title: "Returned to Officer", number: 0 },
            { title: "Returned to YOU", number: 0 },
          ],
        }}
      /> */}
      {/* <Row>
        Service Dashboards
        <a href="dashboard-head-env-audit">1. Environmental Audit Service</a>
        <br></br>
      </Row> */}
      <Card>
        <CardHeader>Submitted Applications</CardHeader>
        <CardBody>
          {mounted ? (
            <Row>
              <Col sm="12">
                <Applications
                  assignStaff={true}
                  data={submitted}
                  user={props.user}
                  paginate={paginate}
                />
              </Col>
            </Row>
          ) : null}
        </CardBody>
      </Card>
    </Col>
  )
}

export default tabs
